var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartpayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM6.87504 4.125C6.11565 4.125 5.50004 4.74061 5.50004 5.5C5.50004 6.25939 6.11565 6.875 6.87504 6.875H8.25004C9.26793 6.875 10.1567 7.42802 10.6321 8.25H6.87504C6.11565 8.25 5.50004 8.86561 5.50004 9.625C5.50004 10.3844 6.11565 11 6.87504 11H10.6321C10.1567 11.822 9.26793 12.375 8.25004 12.375H6.87504C6.3189 12.375 5.81753 12.71 5.60471 13.2238C5.39188 13.7376 5.50952 14.329 5.90277 14.7223L10.0278 18.8473C10.5647 19.3842 11.4353 19.3842 11.9723 18.8473C12.5093 18.3103 12.5093 17.4397 11.9723 16.9027L9.93249 14.8629C11.7181 14.2898 13.106 12.829 13.5768 11H15.125C15.8844 11 16.5 10.3844 16.5 9.625C16.5 8.86561 15.8844 8.25 15.125 8.25H13.5768C13.4512 7.76219 13.2604 7.30057 13.0142 6.875H15.125C15.8844 6.875 16.5 6.25939 16.5 5.5C16.5 4.74061 15.8844 4.125 15.125 4.125H6.87504Z",
    fill: "#4D3ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartpayment);
export default __webpack_public_path__ + "static/media/partpayment.106cdb593baeb4499d79fc867f7d38da.svg";
export { ForwardRef as ReactComponent };